import { PublishAssessmentUI } from "features";

const PublishAssessment = () => {


  return (
    <>
      <PublishAssessmentUI />
    </>
  );
};

export { PublishAssessment };
